import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

const ITEM_HEIGHT = 50;

export default () =>
  createStyles({
    filtersButton: {
      borderColor: palette.blue,
      color: palette.blue,
    },
    searchItem: {
      padding: '4px 16px',
      borderBottom: `1px solid ${palette.grey200}`,
      position: 'sticky',
      top: 0,
      '& input': {
        fontSize: 14,
      },

      '& .closeIcon': {
        cursor: 'pointer',
      },
    },
    listContainer: {
      maxHeight: ITEM_HEIGHT * 4.4,
      overflowY: 'auto',
    },
    searchIcon: {
      color: palette.gray,
      opacity: 0.5,
    },
    closeIcon: {
      cursor: 'pointer',
    },
    hideCloseIcon: {
      visibility: 'hidden',
    },
  });
